import React, { useEffect, useState } from "react";
import { Box, Button, Grid, TextField, Typography } from "@material-ui/core";
import IrancellIcon from '../../../assets/images/irancell-icon.svg';
import HamrahAvalIcon from '../../../assets/images/hamrahAvalIcon.svg';
import RightelIcon from '../../../assets/images/rightelIcon.svg';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { useDispatch } from "react-redux";
import { SetChargePackage } from "../../../redux/chargePackage/actions";
import { useHistory } from 'react-router-dom'
import InputSeparator from "../../../components/input-seprator"
import { opratorSelector } from "../../../utils/opratorSelector"
import CustomInputNumber from "../../../components/input-number"

const ChargeView = () => {
  const [formValue, setFormValue] = useState<any>({
    'charge_type_id': 1,
    "mobile_number": undefined,
    "operator_type_id": undefined,
    "simcard_type_id": 1,
    "amount": undefined
  })
  const [formErr, setFormErr] = useState<any>({})
  const [redirect, setRedirect] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const width = window.innerWidth;


  const handleFormValue = ({ target: { name, value } }: any) => {
    setFormValue({
      ...formValue,
      [name]: value
    })
  }

  const handleButton = (name: string, value: any) => {
    setFormValue({
      ...formValue,
      [name]: value
    })
  }

  const validate = (submit: any) => {
    let _errors = {}
    let hasError = false
    Object.keys(formValue).map((item: any) => {
      // @ts-ignore
      if (!formValue[item]) {
        _errors = { ..._errors, [item]: "این فیلداجباری است" }
        hasError = true
      } else if (formValue['mobile_number']?.slice(0, 2) !== "09") {
        _errors = { ..._errors, ['mobile_number']: "شماره موبایل باید با 09 شروع شود" }
        hasError = true
      } else if (formValue['mobile_number']?.length !== 11) {
        _errors = { ..._errors, ['mobile_number']: "شماره موبایل باید 11 رقم باشد" }
        hasError = true
      }

    })
    setFormErr(_errors)
    if (!hasError) submit()
  }

  const onSubmit = () => {
    setFormValue({
      ...formValue,
      ['amount']: parseInt(formValue['amount'])
    })
    dispatch(SetChargePackage(formValue))

    setRedirect(true)
  }

  useEffect(() => {
    dispatch(SetChargePackage({}))
  }, [])

  useEffect(() => {
    setFormValue({
      ...formValue,
      ['simcard_type_id']: 1
    })

  }, [formValue['operator_type_id']])

  useEffect(() => {
    let op = opratorSelector(formValue['mobile_number'])
    setFormValue({
      ...formValue,
      operator_type_id: op
    })
  }, [formValue['mobile_number']])

  useEffect(() => {
    if (formValue['operator_type_id'] === 2) {
      setFormValue({
        ...formValue,
        ['charge_type_id']: 1
      })
    }
  }, [formValue['operator_type_id']])

  const valid = ({ target: { name, value } }: any) => {
    let event = {
      target: {
        name: name,
        value: value
      }
    }
    switch (name) {
      case 'mobile_number':
        if (value.length < 12) {

          handleFormValue(event)
        }
        break;
      default:
        handleFormValue(event)
    }
  }

  if (redirect)
    history?.push("/payment")

  return (
    <>
      {/* @ts-ignore */}
      <Box className="dir box mainBox p-res centerinput">
        <Grid container>
          <Grid item xs={12}>
            {/* @ts-ignore */}
            <Box display="flex" alignItems="center">
              <Typography
                className="text-muted text-right small"
                style={{ width: "25%", whiteSpace: 'nowrap', marginLeft: '5px' }}
              >
                شماره موبایل
              </Typography>
              <CustomInputNumber
                placeholder="09"
                type={"number"}
                name="mobile_number"
                variant="outlined"
                className="w-100 my-3 input-res"
                size="small"
                onChange={valid}
                autocomplete={"on"}
                value={formValue["mobile_number"]}
                dir="rtl"
              />
            </Box>

            <Typography className="textError">
              {formErr && formErr["mobile_number"]}
            </Typography>
          </Grid>
        </Grid>
        <Typography className="textError">
          {formErr && formErr["charge_type_id"]}
        </Typography>

        <Grid container className="m-0" style={{ marginBottom: '5px', flexWrap: 'nowrap' }}>
          <Grid item>
            <InfoOutlinedIcon color="secondary" className="resize ml-2" />
          </Grid>
          <Grid item justifyContent="flex-end">
            <Typography className="small text-right text-muted">
              در صورتی که ترابرد کرده اید اپراتور خود را تغییر دهید
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={3} className="op-res">
            {/* @ts-ignore */}
            <Box
              p={1}
              display="flex"
              justifyContent="center"
              className="flexi"
            >
              <Button
                variant="contained"
                className={`btn ${formValue["operator_type_id"] === 1 ? "Active" : ""
                  } btn-res`}
                onClick={() => handleButton("operator_type_id", 1)}
              >
                <img src={IrancellIcon} width="60px" className="img-res" />
              </Button>
            </Box>
          </Grid>
          <Grid item xs={3} className="op-res">
            {/* @ts-ignore */}
            <Box
              p={1}
              display="flex"
              justifyContent="center"
              className="flexi"
            >
              <Button
                variant="contained"
                className={`btn ${formValue["operator_type_id"] === 2 ? "Active" : ""
                  } btn-res`}
                onClick={() => handleButton("operator_type_id", 2)}
              >
                <img src={HamrahAvalIcon} width="60px" className="img-res" />
              </Button>
            </Box>
          </Grid>
          <Grid item xs={3} className="op-res">
            {/* @ts-ignore */}
            <Box
              p={1}
              display="flex"
              justifyContent="center"
              className="flexi"
            >
              <Button
                variant="contained"
                className={`btn ${formValue["operator_type_id"] === 3 ? "Active" : ""
                  } btn-res`}
                onClick={() => handleButton("operator_type_id", 3)}
              >
                <img src={RightelIcon} width="60px" className="img-res" />
              </Button>
            </Box>
          </Grid>
          {formErr["operator_type_id"] && (
            <Grid item xs={12}>
              <Typography className="textError">
                {formErr["operator_type_id"]}
              </Typography>
            </Grid>
          )}
          {
            formValue['operator_type_id'] !== 2 && <Grid container spacing={1} className="mt-1 h-100 mb-res">
              <Grid item xs={12} md={4} style={{ height: 'fit-content' }}>
                <Typography className="text-muted" style={{ fontSize: '13px !important' }}>نوع شارژ:</Typography>
              </Grid>
              <Grid item xs={6} md={4} className="charge_type rr" style={{ height: 'fit-content' }}>
                <Button
                  onClick={() => handleButton("charge_type_id", 2)}
                  variant={
                    formValue["charge_type_id"] === 2 ? "contained" : "text"
                  }
                  className={`w-100 round  ${formValue["charge_type_id"] === 2
                    ? "typeBackground text-white"
                    : "bg-white text-dark"
                    }`}
                  size="small"
                  style={{ fontSize: '11px !important' }}
                >
                  {formValue['operator_type_id'] === 3 ? 'شور انگیز' : "شگفت انگیز"}
                </Button>
              </Grid>
              <Grid item xs={6} md={4} className="charge_type lr" style={{ height: 'fit-content' }}>
                <Button
                  onClick={() => handleButton("charge_type_id", 1)}
                  variant={
                    formValue["charge_type_id"] === 1 ? "contained" : "text"
                  }
                  className={`w-100 round  ${formValue["charge_type_id"] === 1
                    ? "typeBackground text-white"
                    : "bg-white text-dark"
                    }`}
                  size="small"
                  style={{ fontSize: '11px !important' }}
                >
                  عادی
                </Button>
              </Grid>
            </Grid>
          }

        </Grid>

        <Grid container>
          <Grid item xs={12}>
            {/* @ts-ignore */}
            <Box display="flex" alignItems="center">
              <Typography
                className="text-muted text-right small"
                style={{ width: "40%", whiteSpace: 'nowrap', marginLeft: '5px' }}
              >
                مبلغ مورد نظر (ریال)
              </Typography>
              <InputSeparator
                id="outlined-basic"
                variant="outlined"
                className="w-100 round amount"
                size="small"
                type={"text"}
                color="primary"
                name="amount"
                onChange={handleFormValue}
                value={formValue["amount"]}
                placeholder={"مبلغ را وارد کنید"}
                maxLength={9}
              />
            </Box>

            <Typography className="textError">
              {formErr["amount"] && formErr["amount"]}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1} justifyContent="space-between" style={{ marginTop: "10px" }}>
          <Grid item xs={6} md={3}>
            {/* @ts-ignore */}
            <Box display="flex" justifyContent="center">
              <Button
                variant="contained"
                size="small"
                className="w-100 btn-warning round"
                onClick={() => handleButton("amount", "20000")}
              >
                20,000
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6} md={3}>
            {/* @ts-ignore */}
            <Box display="flex" justifyContent="center">
              <Button
                variant="contained"
                size="small"
                className="w-100 btn-warning round"
                onClick={() => handleButton("amount", "50000")}
              >
                50,000
              </Button>
            </Box>
          </Grid>

          <Grid item xs={6} md={3}>
            {/* @ts-ignore */}
            <Box display="flex" justifyContent="center">
              <Button
                variant="contained"
                size="small"
                className="w-100 btn-warning round"
                onClick={() => handleButton("amount", "100000")}
              >
                100,000
              </Button>
            </Box>
          </Grid>

          <Grid item xs={6} md={3}>
            {/* @ts-ignore */}
            <Box display="flex" justifyContent="center">
              <Button
                variant="contained"
                size="small"
                className="w-100 btn-warning round"
                onClick={() => handleButton("amount", "200000")}
              >
                200,000
              </Button>
            </Box>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            {/*<input type="submit" className="w-100 round-btn mt-5"*/}
            {/*       color="primary" value="ادامه"/>*/}
            <Button
              variant="contained"
              className="w-100 text-white typeBackground round-btn CBuyButton"
              size={width > 770 ? "large" : "small"}
              onClick={() => validate(onSubmit)}
            >
              ادامه
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}


export default ChargeView;
